import { Box, Stack, Typography } from '@mui/material';
import FieldListV2 from '/@/components/field-list-v2';
import { _ } from '/@/locale';
import { getNodeScopeFilters, type NodeScopeFilters } from '/@/utils/node-scope';

const FieldSection = ({
    userNodeId,
    nodeScope = getNodeScopeFilters('growers'),
    title,
    subtitle,
}: {
    userNodeId?: number;
    nodeScope?: NodeScopeFilters;
    title?: string;
    subtitle?: string;
}) => {
    return (
        <Stack spacing={3}>
            <Stack spacing={1}>
                <Typography color='primary' variant='h5'>
                    {title}
                </Typography>
                <Typography color='primary.mui.inactive' variant='body1'>
                    {subtitle}
                </Typography>
            </Stack>

            <Stack
                py={3}
                px={2}
                spacing={3}
                sx={{
                    background: 'white',
                    border: (t) => `1px solid ${t.palette.divider}`,
                }}
            >
                <Box>
                    {userNodeId && (
                        <FieldListV2
                            userNodeId={userNodeId}
                            nodeScope={nodeScope}
                            emptyMessage={_('El representante de ventas aún no tiene productores cargados')}
                        />
                    )}
                </Box>
            </Stack>
        </Stack>
    );
};

export default FieldSection;
